import { render, staticRenderFns } from "./ValidationRequestErrorAlert.vue?vue&type=template&id=f5edf500"
import script from "./ValidationRequestErrorAlert.vue?vue&type=script&lang=js"
export * from "./ValidationRequestErrorAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports